export const GOOGLE_API_KEY = "AIzaSyAwL31kB997QIbZOJgfBdGHUcht3NB8R3Y";

export const GOOGLE_MAP_ZOOM_LEVEL_ON_SINGLE_PIN = 17;
export const GOOGLE_MAP_DEFAULT_PADDING_VERTICAL = 30;
export const GOOGLE_MAP_DEFAULT_PADDING_HORIZONTAL = 80;
export const GOOGLE_MAP_MARKER_WIDTH = 30;
export const GOOGLE_MAP_MARKER_HEIGHT = 48;

export const GOOGLE_MAP_STYLE_CONFIGURATION: google.maps.MapTypeStyle[] = [
    {
        featureType: "all",
        elementType: "all",
        stylers: [
            {
                saturation: -100
            },
            {
                lightness: 15
            }
        ]
    }
];
